export default "__VITE_PUBLIC_ASSET__333b181c__"